type GalleryImageProps = {
  src: string;
  alt: string;
  containerClass: string;
};

const topRowImages: GalleryImageProps[] = [
  { src: "https://cdn.prod.website-files.com/68b29a3a3c940a53d3f1b4e0/68b45513d2ddbc8f125feb79_0SE7AXQ2fF2cbI9VpejbLJajyDM.avif", alt: "Abstract art with orange and dark tones", containerClass: 'h-80' },
  { src: "https://cdn.prod.website-files.com/68b29a3a3c940a53d3f1b4e0/68b45513d2ddbc8f125feb7d_57FQ23G8YHiC363dq9ZuPtwr0.avif", alt: "Woman smiling in a natural setting", containerClass: 'h-64' },
  { src: "https://cdn.prod.website-files.com/68b29a3a3c940a53d3f1b4e0/68b45513d2ddbc8f125feb81_3.avif", alt: "Woman with pink hair posing", containerClass: 'h-80' },
  { src: "https://cdn.prod.website-files.com/68b29a3a3c940a53d3f1b4e0/68b45513d2ddbc8f125feb85_4.avif", alt: "Man smiling against a pink background", containerClass: 'h-64' },
  { src: "https://cdn.prod.website-files.com/68b29a3a3c940a53d3f1b4e0/68b45513d2ddbc8f125feb8d_5.avif", alt: "Woman in an orange shirt", containerClass: 'h-80' },
  { src: "https://cdn.prod.website-files.com/68b29a3a3c940a53d3f1b4e0/68b45513d2ddbc8f125feb89_6.avif", alt: "Perfume bottle product shot", containerClass: 'h-64' },
  { src: "https://cdn.prod.website-files.com/68b29a3a3c940a53d3f1b4e0/68b45513d2ddbc8f125feb95_7.avif", alt: "Woman wearing a hat", containerClass: 'h-80' }
];

const bottomRowImages: GalleryImageProps[] = [
  { src: "https://cdn.prod.website-files.com/68b29a3a3c940a53d3f1b4e0/68b45513d2ddbc8f125feb91_8.avif", alt: "Abstract blue and green shapes", containerClass: 'h-64' },
  { src: "https://cdn.prod.website-files.com/68b29a3a3c940a53d3f1b4e0/68b45513d2ddbc8f125feba6_9.avif", alt: "Man with a thoughtful expression", containerClass: 'h-80' },
  { src: "https://cdn.prod.website-files.com/68b29a3a3c940a53d3f1b4e0/68b45513d2ddbc8f125feba2_10.avif", alt: "Pastel colored packaging design", containerClass: 'h-64' },
  { src: "https://cdn.prod.website-files.com/68b29a3a3c940a53d3f1b4e0/68b45513d2ddbc8f125feb99_11.avif", alt: "Graphic design with text", containerClass: 'h-80' },
  { src: "https://cdn.prod.website-files.com/68b29a3a3c940a53d3f1b4e0/68b45513d2ddbc8f125feb9d_12.avif", alt: "Woman smiling brightly", containerClass: 'h-64' },
];

const MarqueeRow = ({ images, duration, reverse = false }: { images: GalleryImageProps[]; duration: string; reverse?: boolean }) => {
  const animationClass = reverse ? "animate-marquee-reversed" : "animate-marquee-normal";

  const ImageSet = () => (
    <div className="flex flex-shrink-0 items-center justify-around gap-4 px-2">
      {images.map((img, i) => (
        <div key={i} className={`group relative w-auto overflow-hidden rounded-xl ${img.containerClass}`}>
          <img
            src={img.src}
            alt={img.alt}
            className="h-full w-auto object-cover transition-transform duration-300 ease-in-out group-hover:scale-105"
            loading={i < 5 ? "eager" : "lazy"}
          />
        </div>
      ))}
    </div>
  );

  return (
    <div className={`flex ${animationClass}`} style={{ animationDuration: duration }}>
      <ImageSet />
      <ImageSet />
    </div>
  );
};

const CommunityGallery = () => {
    const css = `
        @keyframes marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        @keyframes marqueeReverse {
          from { transform: translateX(-50%); }
          to { transform: translateX(0); }
        }
        .animate-marquee-normal {
          animation: marquee linear infinite;
        }
        .animate-marquee-reversed {
          animation: marqueeReverse linear infinite;
        }
      `;

    return (
        <div className="relative w-full h-full">
            <style>{css}</style>
            <div className="relative flex flex-col gap-4 overflow-hidden">
                <MarqueeRow images={topRowImages} duration="90s" />
                <MarqueeRow images={bottomRowImages} duration="120s" reverse={true} />
            </div>
        </div>
    );
};

export default CommunityGallery;